import React from 'react';
import Layout from '../../Layout';
import TaggerSubheader from '../TaggerSubheader';

const TaggerHelp = () => (
  <Layout className="home">
    <TaggerSubheader/>
    <div className="m-5">
      <h2>Apie lietuvių kalbos pastoviųjų junginių atpažintuvą <i>Colloc</i></h2>
      <h3>Failų įkėlimas</h3>
      <p>
        Norėdami pasinaudoti lietuvių kalbos pastoviųjų junginių (toliau PJ) atpažintuvu, įkelkite pasirinktus
        tekstinius failus juos nutempdami (<i>drag&drop</i>) arba paspaudę mygtuką „Įkelti“ ir pasirinkę
        norimus failus. Leidžiama apdoroti tekstinius failus, kurie ne didesni nei 0,5 MB ir kuriuose naudojama
        UTF-8 koduotė. Joks išankstinis failų apdorojimas nereikalingas. Įrankyje įkeltas tekstinis failas
        nuskaitomas, tekstas suskaidomas sakiniais ir žodžiais, sužymimos kalbos dalys ir PJ.
      </p>
      <h3>Rezultatų pateikimas</h3>
      <p>
        Kiekvienas įkeltas ir apdorotas dokumentas yra pavaizduojamas atskiroje kortelėje. Kiekvienos kortelės
        pavadinimas sutampa su įkelto failo pavadinimu. Paspaudus ant pasirinktos kortelės pavadinimo yra matoma:
      </p>
      <ol>
        <li>apdorotas tekstas;</li>
        <li>duomenų parsisiuntimo galimybė.</li>
      </ol>
      <p>
        Kiekvienas apdoroto teksto sakinys pateikiamas naujoje eilutėje, PJ yra pajuodinti. Įrankis gali atpažinti
        neriboto ilgio PJ be jokio įsiterpimo arba su vieno žodžio įsiterpimu. Žodžiai, einantys vienas po kito ir
        pažymėti kaip PJ dalis, yra laikomi vienu junginiu, pavyzdžiui, sakinyje: „Ozonas, O3 – deguonies
        <b> alotropinė atmaina</b>, jo molekulę sudaro trys <b>deguonies atomai</b>.“ yra atpažinti du junginiai:
        <i> alotropinė atmaina</i> ir <i>deguonies atomai</i>. Jei šio sakinio dalis būtų sužymėta taip: „Ozonas, O3 –
        <b> deguonies</b> alotropinė <b>atmaina</b>, jo molekulę ...“, junginiu reikėtų laikyti <i>deguonies (*)
        atmaina</i>, (ženklu <i>(*)</i> pažymėtas įsiterpimas). Jei tarp PJ priklausančių žodžių yra įsiterpęs
        daugiau nei vienas žodis, tai šie žodžiai priklauso skirtingiems PJ.
      </p>
      <h3>Duomenų parsisiuntimas</h3>
      <p>
        Duomenis galima atsiųsti dviem formatais: kaip junginių sąrašą ir anotuotą tekstą. Sąrašas atsiunčiamas
        kaip tekstinis failas, kur kiekvienas junginys pateikiamas naujoje eilutėje. Anotuotas tekstas taip pat
        atsiunčiamas kaip tekstinis failas, tik čia kiekvienas žodis yra pateikiamas naujoje eilutėje tokiu
        formatu: „&#60;žodis> &#60;tabuliacijos ženklas> &#60;nustatyta žodžio kalbos dalis> &#60;tabuliacijos ženklas>
        &#60;priklausymo PJ žymė> &#60;naujos eilutės simbolis>“, tuščia eilutė žymi sakinio pabaigą. Priklausymo PJ
        žymė gali būti: MWE (žodis priklauso PJ) ir O (žodis nepriklauso PJ).
      </p>
    </div>
  </Layout>
);

export default TaggerHelp;
